import { ShieldCheck, FlaskConical, Tag, Truck } from "lucide-react";
import Reveal from "./Reveal";

const CAPABILITIES = [
  {
    icon: ShieldCheck,
    title: "Verified Suppliers",
    desc: "Every supplier in our network is vetted for production capacity, compliance, and quality history.",
  },
  {
    icon: FlaskConical,
    title: "Sample Coordination",
    desc: "We arrange product samples before bulk orders, so you can verify quality firsthand.",
  },
  {
    icon: Tag,
    title: "Custom Branding",
    desc: "Private label, custom packaging, and OEM branding available across all categories.",
  },
  {
    icon: Truck,
    title: "Consolidated Shipping",
    desc: "Multiple product categories combined into single shipments to reduce freight costs.",
  },
];

export default function SourcingCapabilities() {
  return (
    <section id="capabilities" className="section-shell bg-surface-alt/50">
      <div className="section-inner">
        <Reveal>
          <div className="text-center mb-8 md:mb-10">
            <h2 className="font-serif text-3xl md:text-5xl font-bold text-primary tracking-tight">
              Sourcing Capabilities
            </h2>
          </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {CAPABILITIES.map((item, i) => {
            const Icon = item.icon;
            return (
              <Reveal key={item.title} delay={i * 80}>
                <div className="h-full bg-surface border border-border rounded-2xl p-6 hover:border-accent/50 transition-colors">
                  <div className="w-11 h-11 rounded-xl bg-accent/15 flex items-center justify-center mb-4">
                    <Icon size={20} className="text-accent" />
                  </div>
                  <h3 className="font-serif text-lg font-bold text-primary">{item.title}</h3>
                  <p className="mt-2.5 text-sm text-muted leading-relaxed">{item.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
